import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import Footer from '../Partials/SaleFooter/SaleFooter';
import { setIsDisplayPopupForHelp, reportDWH} from '../energySaleBlockSlice';
import VIcon from '../images/v-icon.svg'
import EpiContext from '@episerver/spa-core/Spa';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';

const SuccessPage = (props) => {

  //page params
  let title = props.epiText.title;
  let subTitle = 'תוכנית ' + props.selectedPackage.title;
  let iconType = VIcon;
  let btnText = 'לעדכונים באזור האישי';
  let isDisplayWhatsApp = false;
  let currentPageFunction = handlePageContinue;
  const formid = 'energySaleBlock';
  const isDisplayFooter = true;
  //page params

  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: 'Energy_Step9_SuccessPage',
      step: '9',
      action: 'SuccessPage',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Success', status: 'Completed', messageText: 'Success' })
    if (runSideEffects()) {
    }
  },
  [],);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <Image className='energy-sale-icon' src={iconType} alt='' />
      <h1 className='energy-sale-title' dangerouslySetInnerHTML={{__html: title}}></h1>
      <h2 className='energy-sale-sub-title extra-bold purple'> {subTitle} </h2>
    </div>
  );

  let currentPageView = (
    <div className='success-msg'>
      <p>מספר האישור : {props.orderId}</p>
      <div className='time-text' dangerouslySetInnerHTML={{__html: props.epiText.timeText}}/>
      <p>אל דאגה, נעדכן אותך בכל שלב בתהליך. <br/>
      אישור הצטרפות ועדכונים ישלחו בהודעה <br/>
      ל-{props.phoneNumber}</p>
    </div>
  );

  return (
    <>
      <div className='energy-sale-content-wrapper'>
        {currentPageHeadline}
        <div className='energy-sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
            {currentPageView}
          </form>
        </div>
      </div>
      <Footer isDisplayFooter={isDisplayFooter} isDisplayWhatsAppIcon={isDisplayWhatsApp} btnText={btnText} onclick={currentPageFunction} formid={formid} />
    </>
  );

  function handlePageContinue() {
    EpiContext.navigateTo(Config.lobbyUrl);
  }

  function handleSubmit(event) {
    event.preventDefault();
  }


};

const mapStateToProps = (state) => {
  return {
    phoneNumber: state.energySaleBlock.otpDetails.phoneNumber,
    orderId: state.energySaleBlock.summaryDetails.orderId,
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage,
    selectedPackage: state.energySaleBlock.selectedPackage,
    epiText: state.energySaleBlock.energySaleBlockData.epiText.successPage
  };
};

const mapDispatchToProps = {
  setIsDisplayPopupForHelp,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
